import React from 'react';
import { Card } from '../Card';
import { Heading } from '../Heading';
import { Flex, Typography, Image } from 'antd';
import { useTranslation } from 'react-i18next';
import { useOrderProofOfDelivery } from '@/hooksApi';
import useBoxySelect from '@/hooks/useBoxySelect';

//  Define the Props interface
interface ProofOfDeliveryCardProps {
  orderUid?: string;
  enabled?: boolean;
}

//  Update the component to accept props
const ProofOfDeliveryCard: React.FC<ProofOfDeliveryCardProps> = ({ orderUid, enabled = true }) => {
  const { t } = useTranslation();

  // Core closes carrier-proof to Boxy Select merchants with a 403 by design — don't ask.
  const isBoxySelect = useBoxySelect();
  const { data } = useOrderProofOfDelivery(orderUid as string, enabled && !isBoxySelect);

  const response = data?.object.proof;

  if (!response || (Array.isArray(response) ? response : [response]).length === 0) return null;
  return (
    <Card extraClassName='!shadow-card-dark mb-4'>
      <Heading
        title={t('proof_of_delivery')}
        fontSize='text-lg'
        fontWeight='font-bold'
        extraClassName='uppercase'
      />
      <Flex className='py-4' gap={16}>
        {response
          ? (Array.isArray(response) ? response : [response]).map((item) => (
              <div className='rounded-lg overflow-hidden' key={item}>
                <Image
                  src={item}
                  width={60}
                  height={60}
                  style={{ objectFit: 'cover' }}
                  preview={{
                    src: item,
                    mask: <span style={{ borderRadius: '10px' }}>{t('view')}</span>,
                  }}
                />
              </div>
            ))
          : null}
      </Flex>
    </Card>
  );
};

export default ProofOfDeliveryCard;
